import React, { Component } from 'react'
import { TextField, TextFieldProps } from '@deal/components'
import zxcvbn from 'zxcvbn'
import styles from './styles.css'

interface PasswordInputProps extends TextFieldProps {
  strength?: boolean
  onFieldValid: () => void
  onFieldInvalid: () => void
}

interface PasswordInputState {
  strength?: number
  valid: boolean
}

export default class PasswordInput extends Component<PasswordInputProps, PasswordInputState> {
  public static defaultProps = {
    strength: false
  }

  public constructor(props: PasswordInputProps) {
    super(props)

    this.state = {
      valid: false
    }

    this.handleChange = this.handleChange.bind(this)
    this.validatePassword = this.validatePassword.bind(this)
  }

  public handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { value } = event.target
    this.validatePassword(value)

    if (this.props.strength) {
      this.setState({
        strength: zxcvbn(value).score
      })
    }

    if (this.props.onChange) {
      this.props.onChange(event)
    }
  }

  public validatePassword(value: string) {
    const { onFieldValid, onFieldInvalid } = this.props
    const valid = value.length >= 6
    if (valid) {
      onFieldValid()
    } else {
      onFieldInvalid()
    }
    this.setState({ valid })
  }

  public render() {
    const { strength, onChange, ...props } = this.props
    const { valid } = this.state

    let status
    switch (this.state.strength) {
      case 0:
        status = '😞 too weak'
        break
      case 1:
        status = '😕 not great'
        break
      case 2:
        status = '🙂 okay'
        break
      case 3:
        status = '😊 nice!'
        break
      case 4:
        status = '😎 well done!'
        break
    }

    return (
      <div className={status && styles[`inputStrength${this.state.strength}`]}>
        <TextField
          type="password"
          valid={valid}
          display="standard"
          placeholder="&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;"
          onChange={this.handleChange}
          helpText={status ? `Password strength: ${status}` : ''}
          {...props}
        />
      </div>
    )
  }
}
